<template>

</template>

<script>
  export default {
     name: 'Property_Insert_Record',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Property/Property_Insert_Record.vue